export const isLoggedIn = () =>
  fetch(process.env.REACT_APP_LOGIN_VERIFY_API, { credentials: 'include' });
